export default "__VITE_ASSET__D5oZbCa5__"